module.exports = __webpack_public_path__ + "assets/deesse-497d1bde4165b23406906a2ff91c0385.svg";